<template>
<div>
    <h2>{{ $t("homeView.permit")}}</h2>
    <p v-for="(paragraph, i) in store.globalSettings.permissionText ? store.globalSettings.permissionText.split('\n') : ''" class="about" :key="i">
        {{ paragraph }}<br>
    </p>
    <button class="button button-green" @click="backToHome">{{ $t("permissionView.backToHome") }}</button>
</div>
</template>

<script lang="ts">
import { store } from "store";
import { defineComponent } from "vue";

export default defineComponent({
    mounted() {
        this.setTitle();
        window.scrollTo(null, 0);
    },
    data() {
        return {
            store: store
        };
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("homeView.permit") as string;
            store.page.showTopNav = true;
        },
        backToHome() {
            this.$router.push('/');
        }
    }
})

</script>